<span [ngSwitch]="status">
  <span class="badge bg-danger text-light" *ngSwitchCase="'CANCELED'">Annulé</span>
  <span class="badge bg-info text-light" *ngSwitchCase="'OPEN'">Ouvert</span>
  <span class="badge bg-success text-light" *ngSwitchCase="'CONFIRMED'">Confirmé</span>
</span>